export const VIDEO_PLAYER_COLORS = {
  /* we want to use the white color both in light and dark mode */
  WHITE: '#ffffff',
  PROGRESS_BAR_RAIL: '#f2f5fa',
  AUTO_NEXT_OVERLAY_NEXT_ITEM_DURATION: '#c1cad9',
} as const;
